export default '/src/assets/webgl/caris_1/audios/outro.mp3'